import React, { useContext, useRef } from "react";
import { GlobalContext } from "./../Context";
import "./ShareButton.scss";

function ShareButton({title}) {
  const globalContext = useContext(GlobalContext);
  const hiddenInputRef = useRef(null);

  const {
    isShareButtonClicked,
    setisShareButtonClicked
  } = globalContext;

  const shareURL = () => {
    const shareData = {
      title: 'BAC Sucursal',
      text: title,
      url: window.location,
    }

    setisShareButtonClicked(true);
    hiddenInputRef.current.value = window.location;
    hiddenInputRef.current.focus();
    hiddenInputRef.current.select();
    document.execCommand('copy');

    if (navigator.share) {
      navigator.share(shareData);
    }
  }

  return (
    <div className="share-button__container">
      <input className="share-button__hidden-input" type="text" ref={hiddenInputRef}/>
      <button
        className="share-button"
        onClick={shareURL}
      >
        Compartir
      </button>
      {isShareButtonClicked && <span className="share-button__tooltip">¡Se ha copiado el enlace al portapapeles!</span>}
    </div>
  );
};

export default ShareButton;
